import Instance from "../../../../Axios";

// New Actions for the app

const AddFabricante = (yData) => async (dispatch) => {
  await Instance()
    .post(`/energias/fabricantes`, { yData })
    .then(({ data }) => {
      //   console.log(data);
      dispatch({ type: "ADD_FABRICANTE", payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default AddFabricante;
